import React, { createContext, useContext, useMemo, useEffect } from 'react';

const LOCAL_STORAGE_KEY = 'choicemutual-dark-mode';

/**
 * Set to 'dark' or 'light' to force a theme (e.g. for development). Set to '' to use normal resolution.
 * Normal resolution: 1) localStorage choicemutual-dark-mode, 2) REACT_APP_THEME, 3) "light".
 */
const FORCE_THEME = '';

function getInitialTheme() {
  if (FORCE_THEME === 'dark' || FORCE_THEME === 'light') return FORCE_THEME;
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored === 'true' || stored === true) return 'dark';
    if (stored === 'false' || stored === false) return 'light';
  }
  const env = process.env.REACT_APP_THEME;
  if (env) {
    const t = String(env).toLowerCase();
    if (t === 'dark' || t === 'light') return t;
  }
  return 'light';
}

const initialTheme = getInitialTheme();

const ThemeContext = createContext({
  theme: initialTheme,
});

export function ThemeProvider({ children }) {
  const value = useMemo(() => ({ theme: initialTheme }), []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', initialTheme);
  }, []);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
